/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Medal = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.3768 4.91258C12.2751 4.60473 11.8435 4.60473 11.7418 4.91258L10.2742 7.70278L7.48553 8.05837L7.43885 8.06137C7.15225 8.09891 7.04059 8.47897 7.28303 8.66488L9.30538 10.8496L8.72646 14.0511L8.71474 14.0936C8.65225 14.3885 8.99172 14.6209 9.24345 14.431L12.0593 12.7857L14.8752 14.431L14.9117 14.4553C15.1706 14.6058 15.494 14.3511 15.3921 14.0511L14.7366 10.9848L16.8356 8.66488L16.8709 8.63399C17.0766 8.42913 16.9376 8.05837 16.6331 8.05837L13.8444 7.70278L12.3768 4.91258ZM14.8192 9.06429L13.0556 8.8394L12.0593 6.9453L11.063 8.8394L9.3224 9.06135L10.622 10.4654L10.2705 12.4095L12.0593 11.3643L13.7774 12.3682L13.4052 10.6272L14.8192 9.06429Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.0194 3.14108L12.0594 1L8.09937 3.14108L4.26514 5.5V14.5L5.95014 15.5V22.8406L12.0594 21.3L18.4501 22.8406L18.4614 17.2948L16.9501 18.1814V20.9594L12.0594 19.7094L7.45014 20.9594V16.5L12.0594 19L16.0194 16.8589L19.8536 14.5V5.5L16.0194 3.14108ZM12.0594 2.70521L8.84966 4.44062L5.74189 6.35261V13.6474L8.84966 15.5594L12.0594 17.2948L15.2691 15.5594L18.3768 13.6474V6.35261L15.2691 4.44062L12.0594 2.70521Z"
                        fill={color}
                    />
                </svg>
        );
    };
